import { apiService } from "./api.service";
import { IResponseModel } from "@/models/interfaces/response.model.interface";
import { IContentSetVersion } from "@/models/interfaces/content/content-set-version.model.interface";
import { IMultivariateConfigurationRequest } from "@/models/interfaces/multivariate/multivariate-configuration-request.model.interface";
import { IContentSetVersionTemplatesRequest } from "@/models/interfaces/content/content-set-version-templates-request.model.interface";

class ContentSetVersionService {

    private static serviceInstance: ContentSetVersionService;

    private constructor() { }

    public static get instance() {
        return this.serviceInstance || (this.serviceInstance = new this());
    }

    public async GetLive(id: number)
      : Promise<IResponseModel<IContentSetVersion>> {
        return apiService.get(`/api/v1/contentset/${id}/version/live`)
            .then((response) => {
                const result = response.data as IResponseModel<IContentSetVersion>;
                return result;
            })
            .catch((error) => {
                const result: IResponseModel<IContentSetVersion> = {
                    success: false,
                    result: null
                };
                return result;
            });
    }

    public async GetPrevious(id: number)
      : Promise<IResponseModel<IContentSetVersion[]>> {
        return apiService.get(`/api/v1/contentset/${id}/version/previous`)
            .then((response) => {
                const result = response.data as IResponseModel<IContentSetVersion[]>;
                return result;
            })
            .catch((error) => {
                const result: IResponseModel<IContentSetVersion[]> = {
                    success: false,
                    result: null
                };
                return result;
            });
    }

    public async GetConfiguration(id: number)
      : Promise<IResponseModel<IContentSetVersion>> {
        return apiService.get(`/api/v1/contentset/${id}/version/configuration`)
            .then((response) => {
                const result = response.data as IResponseModel<IContentSetVersion>;
                return result;
            })
            .catch((error) => {
                const result: IResponseModel<IContentSetVersion> = {
                    success: false,
                    result: null
                };
                return result;
            });
    }

    public async CreateConfiguration(id: number, name: string)
      : Promise<boolean> {
        return apiService.post(`/api/v1/contentset/${id}/version/configuration`, { name })
            .then((response) => {
                return true;
            })
            .catch((error) => {
                return false;
            });
    }

    public async UpdateMultivariateConfig(id: number, multivariate: IMultivariateConfigurationRequest)
      : Promise<boolean> {
        return apiService.patch(`/api/v1/contentset/version/${id}/multivariate/configuration`, multivariate)
            .then((response) => {
                return true;
            })
            .catch((error) => {
                return false;
            });
    }

    public async RemoveTemplate(id: number, templateId: number)
      : Promise<boolean> {
        return apiService.delete(`/api/v1/contentset/version/${id}/template/${templateId}`)
            .then((response) => {
                return true;
            })
            .catch((error) => {
                return false;
            });
    }

    public async AddTemplate(id: number, templateId: number)
      : Promise<boolean> {
        return apiService.patch(`/api/v1/contentset/version/${id}/template/${templateId}`)
            .then((response) => {
                return true;
            })
            .catch((error) => {
                return false;
            });
    }

    public async UpdateMultivariatePercentages(id: number, templates: IContentSetVersionTemplatesRequest)
        : Promise<boolean> {
            return apiService.patch(`/api/v1/contentset/version/${id}/template`, templates)
            .then((response) => {
                return true;
            })
            .catch((error) => {
                return false;
            });
        }

    public async PromoteConfiguration(contentSetId: number)
        : Promise<boolean> {
            return apiService.patch(`/api/v1/contentset/${contentSetId}/version/promote/configuration`)
            .then((response) => {
                return true;
            })
            .catch((error) => {
                return false;
            });
        }

    public async PromoteWinner(contentSetId: number)
        : Promise<boolean> {
            return apiService.patch(`/api/v1/contentset/${contentSetId}/version/promote/winner`)
            .then((response) => {
                return true;
            })
            .catch((error) => {
                return false;
            });
        }
}

// export a singleton instance in the global namespace
export const contentSetVersionService = ContentSetVersionService.instance;
